import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=706e4ef4&"
import script from "./Accounting.vue?vue&type=script&lang=js&"
export * from "./Accounting.vue?vue&type=script&lang=js&"
import style0 from "./Accounting.vue?vue&type=style&index=0&id=706e4ef4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports